import { PiGhostBold } from "react-icons/pi";

import type { Persona } from "types/Persona";
import VylorLogo from "components/VylorLogo";
import { PRODUCT_NAME } from "utilities/productName";
import { TEAMS_SUPPORT_CHANNEL_URL } from "utilities/supportUrl";
import Markdown from "../Markdown";
import WarningMessage from "./WarningMessage";
import SecurityPrivacy from "./SecurityPrivacy";
import styles from "./WelcomeMessage.module.scss";

interface WelcomeMessageProps {
  persona: Persona;
  incognito?: boolean;
}

export default function WelcomeMessage({
  persona,
  incognito = false,
}: WelcomeMessageProps) {
  return (
    <div className={`${styles.welcomeContainer} pa2 pa0-ns`}>
      <div className="center mv3" style={{ width: "160px" }}>
        <VylorLogo alt="Vylor" />
      </div>

      {persona.welcomeMessage ? (
        <div className="f5 lh-copy mb3">
          <Markdown content={persona.welcomeMessage} />
        </div>
      ) : (
        <div className="f5 lh-copy mb3">
          <b>{PRODUCT_NAME}</b> is an internal chat app providing employees a
          secure way to interact with generative AI models.
        </div>
      )}

      {persona.warningMessage && (
        <WarningMessage
          message={persona.warningMessage}
          personaId={persona.id}
        />
      )}

      {incognito && (
        <div className={`pa3 mb3 ${styles.incognitoNotice}`}>
          <PiGhostBold
            style={{
              verticalAlign: "middle",
              marginRight: "0.4rem",
            }}
          />
          Incognito Chat doesn&apos;t persist chat history, and several features
          are disabled: file uploads, code execution, and advanced AI Personas.
          Refreshing the page will clear this chat.
        </div>
      )}

      <div className="f5 lh-copy mb3">
        For support and feedback, please contact the {PRODUCT_NAME} team on our{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={TEAMS_SUPPORT_CHANNEL_URL}
        >
          teams channel
        </a>
        .
      </div>

      <SecurityPrivacy incognito={incognito} />
    </div>
  );
}
